// /*
// * Broadcast Theme
// *
// * Use this file to add custom Javascript to Broadcast.  Keeping your custom
// * Javascript in this fill will make it easier to update Broadcast. In order
// * to use this file you will need to open layout/theme.liquid and uncomment
// * the custom.js script import line near the bottom of the file.
// */



// // ======= to make the header visible scroll on top =======

// let lastScrollY = window.scrollY;
// const header = document.querySelector('.header__wrapper .theme__header');
// const collectionNav = document.querySelector('.collection__nav.collection__nav--sort.collection__nav--filter');
// const FILTER_STICKY_TOP = 94;

// window.addEventListener('scroll', () => {
//   const currentScrollY = window.scrollY;

//   if (currentScrollY > lastScrollY) {
//     header.style.transform = 'translateY(-100%)';
//     header.style.transition = 'transform 0.9s ease';

//     if (collectionNav) {
//       collectionNav.style.top = '0';
//       collectionNav.style.transition = 'top 0.9s ease';
//     }
//   } else {
//     header.style.transform = 'translateY(0)';
//     header.style.transition = 'transform 0.9s ease';
//     if (collectionNav) {
//       collectionNav.style.top = FILTER_STICKY_TOP + 'px';
//       collectionNav.style.transition = 'top 0.9s ease';
//     }

//   }

//   lastScrollY = currentScrollY;
// });


// Option 1: check URL path
if (window.location.pathname === '/') {

  const headerWrapper = document.querySelector('.header__wrapper');
  const header = document.querySelector('.header__wrapper .theme__header');
  const classList = headerWrapper.classList;
  let isAnimating = false;

  // hijack classList.add/remove for js__header__stuck
  const originalAdd = classList.add.bind(classList);
  const originalRemove = classList.remove.bind(classList);

  classList.add = function (...classes) {
    if (classes.includes('js__header__stuck') && !isAnimating) {
      isAnimating = true;

      header.style.transition = 'transform 0.25s ease-in';
      header.style.transform = 'translateY(-100%)';

      header.addEventListener('transitionend', () => {
        originalAdd('js__header__stuck');
        void header.offsetHeight;

        header.style.transition = 'transform 0.25s ease-out';
        header.style.transform = 'translateY(0)';

        header.addEventListener('transitionend', () => {
          isAnimating = false;
        }, { once: true });
      }, { once: true });

      return;
    }
    originalAdd(...classes);
  };

  classList.remove = function (...classes) {
    if (classes.includes('js__header__stuck') && !isAnimating) {
      isAnimating = true;

      header.style.transition = 'transform 0.25s ease-in';
      header.style.transform = 'translateY(-100%)';

      header.addEventListener('transitionend', () => {
        originalRemove('js__header__stuck');
        void header.offsetHeight;

        header.style.transition = 'transform 0.25s ease-out';
        header.style.transform = 'translateY(0)';

        header.addEventListener('transitionend', () => {
          isAnimating = false;
        }, { once: true });
      }, { once: true });

      return;
    }
    originalRemove(...classes);
  };
}
// // Header Sticky for other pages
// if (window.location.pathname !== '/') {
//   const headerWrapper = document.querySelector('.header__wrapper');
//   if (headerWrapper) {
//     headerWrapper.classList.add('js__header__stuck');

//     // prevent theme from removing the class
//     const originalRemove = headerWrapper.classList.remove.bind(headerWrapper.classList);
//     headerWrapper.classList.remove = function (...classes) {
//       const filtered = classes.filter(c => c !== 'js__header__stuck');
//       if (filtered.length) originalRemove(...filtered);
//     };
//   }
// }






// ======= Variant image filtering by alt text =======
(function () {
  var styleEl = null;

  function normalizeValue(value) {
    return 'variant--' + value.toLowerCase().replace(/\s+/g, '-');
  }

  /* Commented by YAsh */
  // function filterImages(variant, productInfoEl) {
  //   if (!variant || !productInfoEl) return;

  //   var matchValue = normalizeValue(variant.option1 || '');
  //   if (!matchValue) return;

  //   // Inject a <style> tag using CSS attribute selectors to hide non-matching
  //   // variant slides. This avoids any conflict with the theme's inline styles.
  //   if (!styleEl) {
  //     styleEl = document.createElement('style');
  //     styleEl.id = 'variant-image-filter';
  //     document.head.appendChild(styleEl);
  //   }
  //   styleEl.textContent =
  //     '[data-slide][data-variant]:not([data-variant="' + matchValue + '"]) { display: none !important; }\n' +
  //     '[data-thumb-item][data-variant]:not([data-variant="' + matchValue + '"]) { display: none !important; }\n' +
  //     '[data-first-variant-slide] { column-span: all !important; }';

  //   // Use rAF so the browser has recalculated layout (offsetLeft) after CSS change.
  //   requestAnimationFrame(function () {
  //     // First slide of the selected variant (or first shared slide)
  //     var firstMatch = productInfoEl.querySelector('[data-slide][data-variant="' + matchValue + '"]') ||
  //                      productInfoEl.querySelector('[data-slide]:not([data-variant])');
  //     if (!firstMatch) return;

  //     // Mark the first visible slide so it gets full-width (column-span: all)
  //     productInfoEl.querySelectorAll('[data-first-variant-slide]').forEach(function (el) {
  //       el.removeAttribute('data-first-variant-slide');
  //     });
  //     firstMatch.setAttribute('data-first-variant-slide', '');

  //     // If the theme hasn't activated this slide yet (e.g. variant has no
  //     // featured_media assigned in Shopify), activate it now.
  //     var activeSlide = productInfoEl.querySelector('[data-slide].media--active');
  //     if (activeSlide !== firstMatch) {
  //       firstMatch.dispatchEvent(new CustomEvent('theme:media:select', {
  //         bubbles: true,
  //         detail: { id: firstMatch.getAttribute('data-media-id') }
  //       }));
  //     }

  //     // Scroll the slide container so the first matching slide is visible.
  //     var mediaList = productInfoEl.querySelector('[data-product-media-list]');
  //     if (mediaList) {
  //       mediaList.scrollTo({ left: firstMatch.offsetLeft, top: 0, behavior: 'auto' });
  //     }
  //   });
  // }

  /* Yash Code Start for size variant flexibility */

  function filterImages(variant, productInfoEl) {
  if (!variant || !productInfoEl) return;

  // Size keywords — options with these names will be ignored even if text
  var SIZE_OPTION_NAMES = ['size', 'sizes', 'taille', 'größe'];

  // Get option names from the product form
  var optionNames = [];
  productInfoEl.querySelectorAll('[data-option-name]').forEach(function (el) {
    optionNames.push(el.getAttribute('data-option-name').toLowerCase().trim());
  });

  // Pick the correct option value — must be text AND not a size option
  var rawValue = null;
  var options = [variant.option1, variant.option2, variant.option3];

  options.forEach(function (opt, index) {
    if (rawValue) return; // already found one
    if (!opt || opt.trim() === '') return;

    var optionName = (optionNames[index] || '').toLowerCase();
    var isSize = SIZE_OPTION_NAMES.some(function (s) { return optionName.includes(s); });
    var isNumeric = !isNaN(opt.trim());

    // Skip if it's a size option OR a pure number
    if (isSize || isNumeric) return;

    rawValue = opt;
  });

  // Nothing matched (size-only product) → clear filter, show all images
  if (!rawValue) {
    if (styleEl) styleEl.textContent = '';
    return;
  }

  // Color found → filter images by color
  var matchValue = normalizeValue(rawValue);

  if (!styleEl) {
    styleEl = document.createElement('style');
    styleEl.id = 'variant-image-filter';
    document.head.appendChild(styleEl);
  }

  styleEl.textContent =
    '[data-slide][data-variant]:not([data-variant="' + matchValue + '"]) { display: none !important; }\n' +
    '[data-thumb-item][data-variant]:not([data-variant="' + matchValue + '"]) { display: none !important; }\n' +
    '[data-first-variant-slide] { column-span: all !important; }';

  requestAnimationFrame(function () {
    var firstMatch = productInfoEl.querySelector('[data-slide][data-variant="' + matchValue + '"]') ||
                     productInfoEl.querySelector('[data-slide]:not([data-variant])');
    if (!firstMatch) return;

    productInfoEl.querySelectorAll('[data-first-variant-slide]').forEach(function (el) {
      el.removeAttribute('data-first-variant-slide');
    });
    firstMatch.setAttribute('data-first-variant-slide', '');

    var activeSlide = productInfoEl.querySelector('[data-slide].media--active');
    if (activeSlide !== firstMatch) {
      firstMatch.dispatchEvent(new CustomEvent('theme:media:select', {
        bubbles: true,
        detail: { id: firstMatch.getAttribute('data-media-id') }
      }));
    }

    var mediaList = productInfoEl.querySelector('[data-product-media-list]');
    if (mediaList) {
      mediaList.scrollTo({ left: firstMatch.offsetLeft, top: 0, behavior: 'auto' });
    }
  });
}




  document.addEventListener('DOMContentLoaded', function () {
    var productInfoEl = document.querySelector('product-info');
    if (!productInfoEl) return;

    // Apply on page load for the default variant
    var selectedVariantEl = productInfoEl.querySelector('[data-selected-variant]');
    if (selectedVariantEl) {
      try {
        filterImages(JSON.parse(selectedVariantEl.innerHTML), productInfoEl);
      } catch (e) {}
    }

    // Re-apply on every variant change
    if (typeof subscribe !== 'undefined' && window.theme && window.theme.PUB_SUB_EVENTS) {
      subscribe(theme.PUB_SUB_EVENTS.variantChange, function (event) {
        filterImages(event.data.variant, productInfoEl);
      });
    }
  });
})();




// ======= Price range checkboxes =======
(function () {
  function syncPriceInputs(holder) {
    var checked = holder.querySelectorAll('.price-range-checkbox:checked');
    var minInput = holder.querySelector('.price-range-min-input');
    var maxInput = holder.querySelector('.price-range-max-input');

    if (checked.length === 0) {
      minInput.removeAttribute('name');
      maxInput.removeAttribute('name');
    } else {
      var mins = [], maxs = [], hasOpenEnded = false;
      checked.forEach(function (cb) {
        mins.push(parseInt(cb.dataset.bmin, 10));
        if (cb.dataset.openEnded === 'true') {
          hasOpenEnded = true;
        } else {
          maxs.push(parseInt(cb.dataset.bmax, 10));
        }
      });
      minInput.name = minInput.dataset.param;
      minInput.value = Math.min.apply(null, mins);
      if (hasOpenEnded && maxs.length === 0) {
        maxInput.removeAttribute('name');
      } else {
        maxInput.name = maxInput.dataset.param;
        maxInput.value = Math.max.apply(null, maxs);
      }
    }
  }

// ── Gifting Drawer: re-init for AJAX quick-add (scripts in innerHTML don't execute) ──
(function () {
  function initGiftingDrawerById(sid) {
    var wrap      = document.getElementById('gd-wrap-'      + sid);
    var dialog    = document.getElementById('gd-dialog-'    + sid);
    var checkbox  = document.getElementById('gd-box-'       + sid);
    var closeBtn  = document.getElementById('gd-close-'     + sid);
    var submitBtn = document.getElementById('gd-submit-'    + sid);
    var textarea  = document.getElementById('gd-textarea-'  + sid);
    var noteInput = document.getElementById('gd-note-'      + sid);
    var giftInput = document.getElementById('gd-giftwrap-'  + sid);
    var giftLabel = document.getElementById('gd-giftlabel-' + sid);
    var errorMsg  = document.getElementById('gd-error-'     + sid);

    if (!wrap || !dialog || !checkbox) return;
    wrap.setAttribute('data-gd-init', '1');
    document.body.appendChild(dialog);

    var isChecked = false;

    function lockScroll()   { document.body.style.overflow = 'hidden'; }
    function unlockScroll() { document.body.style.overflow = ''; }
    function clearError()   { if (errorMsg) errorMsg.classList.remove('is-visible'); }
    function showError(msg) {
      if (errorMsg) { errorMsg.textContent = msg; errorMsg.classList.add('is-visible'); }
    }

    function openDialog() {
      isChecked = true;
      wrap.classList.add('is-checked');
      if (giftInput) giftInput.value = 'Yes';
      if (giftLabel) giftLabel.value = 'Added';
      lockScroll();
      dialog.showModal();
      dialog.classList.remove('is-closing');
      clearError();
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          dialog.classList.add('is-animating');
          setTimeout(function () {
            dialog.classList.remove('is-animating');
            if (textarea) textarea.focus();
          }, 600);
        });
      });
    }

    function closeDialog(uncheck) {
      var typedNote = textarea ? textarea.value.trim() : '';
      var savedNote = noteInput ? noteInput.value.trim() : '';
      if (!uncheck && typedNote && !savedNote) { showError('Please submit your message before closing.'); return; }
      dialog.classList.add('is-closing');
      unlockScroll();
      clearError();
      setTimeout(function () {
        dialog.classList.remove('is-closing');
        dialog.close();
        if (uncheck) {
          isChecked = false;
          wrap.classList.remove('is-checked');
          if (textarea)  textarea.value  = '';
          if (noteInput) noteInput.value = '';
          if (giftInput) giftInput.value = '';
          if (giftLabel) giftLabel.value = '';
        }
      }, 600);
    }

    checkbox.addEventListener('mousedown', function (e) { e.preventDefault(); e.stopPropagation(); });
    checkbox.addEventListener('click',    function (e) { e.preventDefault(); e.stopPropagation(); isChecked ? closeDialog(true) : openDialog(); });
    checkbox.addEventListener('touchend', function (e) { e.preventDefault(); e.stopPropagation(); isChecked ? closeDialog(true) : openDialog(); });

    closeBtn  && closeBtn.addEventListener('click', function () { closeDialog(false); });
    submitBtn && submitBtn.addEventListener('click', function () {
      var note = textarea ? textarea.value.trim() : '';
      if (!note) { showError('Please write a message before submitting.'); return; }
      clearError();
      if (noteInput) noteInput.value = note;
      if (giftInput) giftInput.value = 'Yes';
      if (giftLabel) giftLabel.value = 'Added';
      closeDialog(false);
    });
    textarea  && textarea.addEventListener('input', function () { if (textarea.value.trim()) clearError(); });
    dialog.addEventListener('click', function (e) {
      var panel = dialog.querySelector('.gd-dialog-inner');
      if (panel && !panel.contains(e.target)) closeDialog(false);
    });
    dialog.addEventListener('cancel', function (e) { e.preventDefault(); closeDialog(false); });
  }

  document.addEventListener('theme:quick-add:open', function () {
    document.querySelectorAll('.gd-wrap[id]:not([data-gd-init])').forEach(function (wrap) {
      initGiftingDrawerById(wrap.id.replace('gd-wrap-', ''));
    });
  });
})();

  function initPriceHolders() {
    document.querySelectorAll('[data-price-checkboxes]').forEach(function (holder) {
      syncPriceInputs(holder);
    });
  }

  document.addEventListener('DOMContentLoaded', initPriceHolders);

  /* Re-sync after AJAX filter DOM replacement */
  document.addEventListener('theme:filter:update', initPriceHolders);
  document.addEventListener('theme:section:rerender', initPriceHolders);

  /* Delegated change — survives AJAX DOM replacement */
  document.addEventListener('change', function (e) {
    if (!e.target.classList.contains('price-range-checkbox')) return;
    var holder = e.target.closest('[data-price-checkboxes]');
    if (!holder) return;
    syncPriceInputs(holder);
    holder.closest('form').submit();
  });
})();
//

// ======= SWYM wishlist: notify after infinite-scroll loads new products =======
(function () {
  function watchAjaxinateContainer(container) {
    var observer = new MutationObserver(function (mutations) {
      var hasNewNodes = mutations.some(function (m) { return m.addedNodes.length > 0; });
      if (hasNewNodes) {
        document.dispatchEvent(new CustomEvent('swym:collections-loaded'));
      }
    });
    observer.observe(container, { childList: true });
  }

  function init() {
    // Watch any existing AjaxinateLoop containers
    document.querySelectorAll('[id^="AjaxinateLoop"]').forEach(watchAjaxinateContainer);

    // Also observe the body for dynamically inserted AjaxinateLoop containers
    // (e.g. filter AJAX reload replaces the entire section HTML)
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          var loops = node.id && node.id.indexOf('AjaxinateLoop') === 0
            ? [node]
            : Array.from(node.querySelectorAll ? node.querySelectorAll('[id^="AjaxinateLoop"]') : []);
          loops.forEach(watchAjaxinateContainer);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });

    // Fire once on initial page load so SWYM picks up the already-rendered products
    document.dispatchEvent(new CustomEvent('swym:collections-loaded'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();/* Mobile footer "Contact" opens the contact drawer */
document.addEventListener('click', function (e) {
  var a = e.target && e.target.closest ? e.target.closest('a.cfm__accordion-link') : null;
  if (a && a.textContent.trim().toLowerCase() === 'contact' && !a.getAttribute('onclick')) {
    e.preventDefault();
    if (typeof openContactDrawer === 'function') { openContactDrawer(); }
  }
}, false);